import React, {Fragment} from 'react'
import * as c from '../../const'
import * as u from '../../utils'
import Logo from '../parts/Logo'

const FOOTER_LINKS = [
  // {name: `Terms Of Use`,    url: c.LINK_TERMS_OF_USE},
  // {name: `Privacy Policy`,  url: c.LINK_PRIVACY_POLICY}
]

const Footer = () => {
  return (
    <footer className={`bg-faded pad-v-1x5`}>
      <div className={`content-width row-bet-cen gap-1 t-sm-col-sta-cen`}>
        <div className={`flex-1`}>
          <Logo />
        </div>

        {u.maybeArr(FOOTER_LINKS) && (
          <div className={`flex-1 row-cen-cen gap-0x5`}>
            {FOOTER_LINKS.map(({name, url}, i) => (
              <Fragment key={name}>
                <a
                  className={`decorate-link`}
                  href={url}
                >
                  {name}
                </a>
                {(i + 1 % 2 !== 0 && i + 1 !== FOOTER_LINKS.length) && (
                  <span className={`fg-graphite`}>|</span>
                )}
              </Fragment>
            ))}
          </div>
        )}
        <div className={`flex-1 text-right t-sm-text-center`}>
          &copy; 2024 {c.SEO_TITLE_SUFFIX}. v{c.APP_VERSION}
        </div>
      </div>
    </footer>
  )
}

export default Footer
